import { ContainerType } from '../types';

const normalizeContainerType = (type: string): ContainerType => {
  /**
   * @todo
   * We should receive the container types as their UID values.
   * This function can be removed once the API is updated.
   */

  if (type === 'gft & etensresten') {
    type = 'GFT';
  }

  if (type === 'plastic, blik en drinkpakken') {
    type = 'PBD';
  }

  return type.trim().toUpperCase() as ContainerType;
};

export default normalizeContainerType;
